// add translations
export const locales = {
  // ...imports,
  en: () => import('./en.json'),
  ar: () => import('./ar.json'),
  bn: () => import('./bn.json'),
  de: () => import('./de.json'),
  es: () => import('./es.json'),
  fr: () => import('./fr.json'),
  ja: () => import('./ja.json'),
  nb: () => import('./nb.json'),
  pt: () => import('./pt.json'),
  ta: () => import('./ta.json'),
  ur: () => import('./ur.json'),
  yue: () => import('./yue.json'),
  zg: () => import('./zg.json'),
  zh: () => import('./zh_cn.json'),
  zh_cn: () => import('./zh_cn.json'),
  zh_tw: () => import('./zh_tw.json'),
  cs: () => import('./cs.json'),
  hu: () => import('./hu.json'),
  sv: () => import('./sv.json'),
  no: () => import('./no.json'),
  nl: () => import('./nl.json'),
  tr: () => import('./tr.json'),
  da: () => import('./da.json'),
  lt: () => import('./lt.json'),
  et: () => import('./et.json'),
  lv: () => import('./lv.json'),
  sk: () => import('./sk.json'),
  fi: () => import('./fi.json'),
  pl: () => import('./pl.json'),
  it: () => import('./it.json'),
  is: () => import('./is.json'),
  ro: () => import('./ro.json'),
  ru: () => import('./ru.json'),
  el: () => import('./el.json'),
  sr: () => import('./sr.json'),
} as const;

// create an readonly array of all the keys in the locales object
export const localeArray = Object.keys(
  locales,
) as readonly (keyof typeof locales)[];

// create a type where the keys are the values of the array
export type SupportedLanguage = (typeof localeArray)[number];
